<template>
  <div class="panel-item first-panel">
    <div class="title_name">{{ name }}销售数据</div>
    <!-- {{ salesdata }} -->
    <div class="panel-item_flex m_b_20">
      <div class="m_r_15">
        <div style="display: flex;">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">有效付款订单数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_count_order }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div>
        <div style="display: flex;">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">有效结算订单数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_settle_count_order }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
    </div>
    <div class="panel-item_flex m_b_20">
      <div class="m_r_15">
        <div style="display: flex;">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">有效付款总金额</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_sum_pay_amount }}</div>
          <div class="num_txt2">元</div>
        </div>
      </div>
      <div>
        <div style="display: flex;">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">有效结算总金额</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_settle_sum_pay_amount }}</div>
          <div class="num_txt2">元</div>
        </div>
      </div>
    </div>
    <div class="panel-item_flex m_b_20">
      <div class="m_r_15">
        <div style="display: flex;">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">有效付款预估服务费</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_sum_service_amount }}</div>
          <div class="num_txt2">元</div>
        </div>
      </div>
      <div>
        <div style="display: flex;">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">有效结算服务费</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_settle_sum_service_amount }}</div>
          <div class="num_txt2">元</div>
        </div>
      </div>
    </div>
    <div class="panel-item_flex">
      <div class="m_r_15">
        <div style="display: flex; ">
          <img class="money_img" src="../../../assets/money.png" alt="">
          <div class="num_txt">申样总数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.current_send_sample_count }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div>
        <template v-if="module==2 || module==6">
          <div style="display: flex;">
            <img class="money_img" src="../../../assets/money.png" alt="">
            <div class="num_txt">申样发货数</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_express_sample_count }}</div>
            <div class="num_txt2">单</div>
          </div>
        </template>
        <template v-else>
          <div style="display: flex;">
            <img class="money_img" src="../../../assets/money.png" alt="">
            <div class="num_txt">申样达人数</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_distinct_talent_num }}</div>
            <div class="num_txt2">个</div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    module: {
      type: Number,
      default: 1
    },
    name: {
      type: String,
      default: ''
    },
    salesdata: {
      type: Object,
      default: {}
    }
  },
  watch: {
    salesdata(newVal) {
      // console.log('新数据', newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.title_name {
  padding: 30px 0 23px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

.money_img {
  margin-right: 4px;
  width: 39px;
  height: 23px;
}

.num_txt {
  font-weight: 400;
  font-size: 18px;
  color: #F3FFFE;
}

.num_num {
  margin-left: 39px;
  font-weight: 600;
  font-size: 28px;
  color: #00A8FF;
}

.num_txt2 {

  margin-top: 10px;
  margin-left: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #F3FFFE;
}

.panel-item_flex {
  // margin-top: 32px;
  margin-right: 32px;
  margin-left: 32px;
  padding: 0 32rpx;
  display: flex;
  // justify-content: space-between;
}

.m_b_20 {
  margin-bottom: 20px;
}

.m_r_15 {
  width: 220px;
  margin-right: 10px;
}
</style>